/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface VerticalViewpointData {
  isLookingVertical: boolean;
  heading: number;
}

function createBaseVerticalViewpointData(): VerticalViewpointData {
  return { isLookingVertical: false, heading: 0 };
}

export const VerticalViewpointData = {
  encode(message: VerticalViewpointData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.isLookingVertical === true) {
      writer.uint32(8).bool(message.isLookingVertical);
    }
    if (message.heading !== 0) {
      writer.uint32(21).float(message.heading);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VerticalViewpointData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVerticalViewpointData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.isLookingVertical = reader.bool();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.heading = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VerticalViewpointData {
    return {
      isLookingVertical: isSet(object.isLookingVertical) ? globalThis.Boolean(object.isLookingVertical) : false,
      heading: isSet(object.heading) ? globalThis.Number(object.heading) : 0,
    };
  },

  toJSON(message: VerticalViewpointData): unknown {
    const obj: any = {};
    if (message.isLookingVertical === true) {
      obj.isLookingVertical = message.isLookingVertical;
    }
    if (message.heading !== 0) {
      obj.heading = message.heading;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VerticalViewpointData>, I>>(base?: I): VerticalViewpointData {
    return VerticalViewpointData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VerticalViewpointData>, I>>(object: I): VerticalViewpointData {
    const message = createBaseVerticalViewpointData();
    message.isLookingVertical = object.isLookingVertical ?? false;
    message.heading = object.heading ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
